import { Route, Routes, useParams } from "react-router-dom";
// import AdminMain from "../Components/Admin/AdminMain";
import ShowIssues from "../Components/Admin/issues/ShowIssues";
import ShowIssuesList from "../Components/Admin/issues/ShowIssuesList";
import Layout from "../Components/Admin/Layout";
import Login from "../Components/Admin/Login";
import Careers from "../Components/Admin/Pages/Careers";
import Clients from "../Components/Admin/Pages/Cients";
import Dashboard from "../Components/Admin/Pages/Dashboard";
import Library from "../Components/Admin/Pages/Library";
import OfflineContact from "../Components/Admin/Pages/OfflineContact";
import OnlineContact from "../Components/Admin/Pages/OnlineContact";
import SellsTeam from "../Components/Admin/Pages/SellsTeam";
import Subscribe from "../Components/Admin/Pages/Subscribe";
import Task from "../Components/Admin/Pages/Task";
import UserPortalData from "../Components/Admin/Pages/UserPortalData";
import UserTable from "../Components/signin/UserTable/UserTable";
import EmployeeForm from "../Components/Admin/form/EmployeeForm";
import EmployeeAttendance from "../Components/Admin/Pages/EmployeeAttendance";
import Report from "../Components/Admin/Pages/Report";
import EmployeeStatus from "../Components/Admin/Pages/EmployeeStatus";
import AttendanceEmp from "../Components/Admin/Pages/AttendanceEmp";
import EmployeeChat from "../Components/Admin/Pages/EmployeeChat";
import EmployeeChatHere from "../Components/Admin/Pages/EmployeeChatHere";

//import from rankers folder
import RankersDashboard from "../Rankers/RankersDashboard";
import RankersLayout from "../Rankers/RankersLayout";
import Users from "../Rankers/pages/Users";
import Subject from "../Rankers/pages/Subject";
import Topics from "../Rankers/pages/Topics";
import TestSeries from "../Rankers/pages/TestSeries";
import Question from "../Rankers/pages/Question";
import Previousyearquestion from "../Rankers/pages/Previousyearquestion";
import ExcelUpload from "../Rankers/pages/ExcelUpload";
import UserTracking from "../Rankers/Components/UserTracking";


function MainRoutes() {
  const { issueId } = useParams();

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/crm" element={<Login />} />
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/userPortalData" element={<UserPortalData />} />
          <Route path="/library" element={<Library />} />
          <Route path="/showissues" element={<ShowIssues />} />
          <Route path="/usertable" element={<UserTable />} />
          <Route path="/onlineContact" element={<OnlineContact />} />
          <Route path="/offlineContact" element={<OfflineContact />} />
          <Route path="/sellsteam" element={<SellsTeam />} />
          <Route path="/task" element={<Task />} />
          <Route path="/employeeform" element={<EmployeeForm />} />
          <Route path="/employee-attendance" element={<EmployeeAttendance />} />
          <Route path="/employee-report" element={<Report />} />
          <Route path="/chat" element={<EmployeeChat />} />
          <Route path="/chat/:email" element={<EmployeeChatHere />} />           
          <Route path="/attendance-day/:id" element={<AttendanceEmp />} />
          <Route
            path="/employee-report/status/:id"
            element={<EmployeeStatus />}
          />
          <Route
            path={`/showissueslist/:${issueId}`}
            element={<ShowIssuesList />}
          />
          {/* <Route path="/home" element={<AdminMain />} /> */}
        </Route>


        <Route element={<RankersLayout />}>
          <Route path="/rankers/dashboard" element={<RankersDashboard />} />
          <Route path="/rankers/users" element={<Users />} />
          <Route path="/rankers/subjects" element={<Subject />} />
          <Route path="/rankers/topics" element={<Topics />} />
          <Route path="/rankers/test-series" element={<TestSeries />} />
          <Route path="/rankers/questions" element={<Question />} />
          <Route path="/rankers/pyq" element={<Previousyearquestion />} />
          <Route path="/rankers/excel-sheet-upload" element={<ExcelUpload />} />
          <Route path="/rankers/user-tracking" element={<UserTracking />} />
        </Route>
        
      </Routes>
    </>
  );
}

export default MainRoutes;
